import React, { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useBlocker, UNSAFE_DataRouterContext } from "react-router"
import { useBeforeunload } from "react-beforeunload"

interface Props {
  isEnabled?: boolean
}

const UnsavedChangesBlocker: React.FC<{ isEnabled?: boolean; message: string }> = ({
  isEnabled,
  message
}) => {
  const blocker = useBlocker(!!isEnabled)

  useEffect(() => {
    if (blocker.state === "blocked") {
      const proceed = window.confirm(message)
      if (proceed) {
        blocker.proceed()
      } else {
        blocker.reset()
      }
    }
  }, [blocker, message])

  return null
}

const UnsavedChangesPrompt: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation(["shared"])
  const message = t("shared:unsavedChangesPrompt")
  const inDataRouter = Boolean(useContext(UNSAFE_DataRouterContext))

  useBeforeunload((event: BeforeUnloadEvent) => {
    if (props.isEnabled) {
      event.preventDefault()
    }
  })

  if (!inDataRouter) {
    return null
  }

  return <UnsavedChangesBlocker isEnabled={props.isEnabled} message={message} />
}

export default UnsavedChangesPrompt
